import { createFileRoute } from '@tanstack/react-router'
import { JobCandidates } from '@/features/job-detail/candidates'

export const Route = createFileRoute('/_authenticated/jobs/$jobId/candidates')({
  component: JobCandidates,
})
